import React from 'react';
import { CallNow } from '../../../CallNow';

interface Props {
  whatsapp?: string;
  phone?: string;
  companyName?: string;
  name?: string;
  dataValue?: string | any;
  contacts?: { infoContact: string }[];
  description?: string;
}

export const ShopContact = ({ whatsapp, phone, name, dataValue, contacts, description }: Props) => {
  return (
    <section>
      <h2 className="f20 abbey fw2 lh-copy ma0 mb12 mb8-ns mb8-l mt24 mt40-m">Contato</h2>
      <div className="flex flex-column flex-row-ns flex-column-m flex-column-l">
        {
          // tslint:disable-next-line: jsx-no-multiline-js
          whatsapp && (
            <CallNow
              adId={0}
              type="small"
              dataValue={dataValue}
              name={name}
              hasToCall={false}
              numberPhone={whatsapp}
            />
          )
        }
        {whatsapp && phone && <div className="mt16-ns mt12 mr12" />}
        {
          // tslint:disable-next-line: jsx-no-multiline-js
          phone && (
            <CallNow
              adId={0}
              type="small"
              name={name}
              hasToCall
              numberPhone={phone}
              dataValue={dataValue}
              contacts={contacts}
            />
          )
        }
      </div>
      {description}
    </section>
  );
};
